import { createNextTableContext } from '@core/table';

export const PostDeclarationTableContext = createNextTableContext();
